module.exports = __webpack_public_path__ + "static/Malaysia-logo-5e9ab07c4d3eaeb7550c323a3725968b.png";